"use client";

import { useTranslations } from "next-intl";
import { FormButtonSelect } from "@/components/form/form-button-select";
import { CaloriesCalculatorTrigger } from "@/features/calories-calculator/components/calories-calculator-trigger";
import type { DietCatalogDetail } from "@/features/diets/types";
import type { ConfigureDietReturnFormType } from "../../forms/configure-diet";
import { FormSection } from "./configure-form-section";
import { MealsBar } from "./meals-bar";
import { MealsButton } from "./meals-button";

export const ConfigureSupervariants = ({
  form,
  diet,
  customError,
}: {
  form: ConfigureDietReturnFormType;
  diet: DietCatalogDetail;
  customError?: string;
}) => {
  const t = useTranslations();

  return (
    <div className="space-y-8">
      <FormSection
        action={<CaloriesCalculatorTrigger className="hidden md:inline-flex" />}
        contentClassName="pb-2 md:pb-6"
        label={t("cart.configuration.caloricity")}
      >
        <>
          <div className="flex w-full flex-col items-start gap-2 md:flex-row md:items-center">
            <FormButtonSelect
              className="flex-row flex-wrap overflow-x-auto pb-2 md:flex-nowrap md:pb-0 [&>div]:w-auto"
              fieldName="kcal"
              fieldOptions={diet.calorifics
                .sort((a, b) => a.calories - b.calories)
                .map((item) => ({
                  label: (
                    <span className="flex w-full items-center justify-between md:block">
                      <span>{t("common.kcal", { kcal: item.calories })}</span>
                    </span>
                  ),
                  value: item.calories.toString(),
                }))}
              form={form}
            />
          </div>
          <CaloriesCalculatorTrigger
            className="my-2 md:hidden"
            variant="button"
          />
        </>
      </FormSection>

      <FormSection
        error={form.getFieldState("meals").invalid}
        id="cart-meals"
        label={t("cart.configuration.numberOfMeals")}
      >
        <>
          <div className="flex w-full space-x-2">
            <FormButtonSelect
              className="w-full"
              classNameButton="flex flex-col text-left w-full md:w-fit py-[10px] md:py-4"
              classNameItem="min-w-0"
              classNameLabel="items-start"
              customError={customError}
              fieldName="meals"
              fieldOptions={
                diet.calorifics
                  .find((c) => c.calories === Number(form.getValues("kcal")))
                  ?.mealsCaloricValue?.map((item) => ({
                    label: (
                      <MealsButton
                        diet={diet}
                        item={item}
                        kcal={Number(form.getValues("kcal"))}
                      />
                    ),
                    value: item.mealId,
                  })) || []
              }
              form={form}
              multi
            />
          </div>
          <MealsBar diet={diet} form={form} />
        </>
      </FormSection>
    </div>
  );
};
